import React, {createContext, useState} from "react";

// create contexts with default values
export const UserContext = createContext()

export function useUser() {
    const [user, setUser] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        postcode: ''
    });
    return [user, setUser];
}
